import { noop } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { type MarketingBannerModalAction, type MarketingBannerModalFooterProps } from '@capsicum/features/feeds/shared';
import { useCallback } from 'react';
import styled from 'styled-components';

import { useMarketingBannerTextColor } from '../../hooks/useMarketingBannerTextColor';

export const MarketingBannerModalFooter = ({
	onClose = noop,
	primary,
	secondary,
	theme
}: MarketingBannerModalFooterProps) => {
	const { buttonColor } = useMarketingBannerTextColor({ theme });

	const createClickListener = useCallback(
		(action?: MarketingBannerModalAction) => {
			if (!action || !action.url) return;
			onClose();
			window.location.href = action.url;
			action.onTrigger?.();
		},
		[onClose]
	);

	const onPrimaryClick = useCallback(() => createClickListener(primary), [primary, createClickListener]);
	const onSecondaryClick = useCallback(() => createClickListener(secondary), [secondary, createClickListener]);

	return (
		<S.Wrapper>
			<Button
				fullWidth
				testID="marketingBannerModalFooter-action-primary"
				text={primary.label}
				onClick={onPrimaryClick}
			/>

			{secondary && (
				<Button
					color={buttonColor}
					fullWidth
					testID="marketingBannerModalFooter-action-secondary"
					text={secondary.label}
					variant="text"
					onClick={onSecondaryClick}
				/>
			)}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.small};
	`;
}
